import { render, staticRenderFns } from "./SdsUpdate.vue?vue&type=template&id=2e68abc3"
import script from "./SdsUpdate.vue?vue&type=script&lang=js"
export * from "./SdsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports